import type { CheckboxProps } from '@archipro-design/aria';
import { Checkbox } from '@archipro-design/aria';
import type { FilterStatesKey } from '../../type/filter-state';
export interface CheckboxFilter {
    kind: 'Checkbox';
    filterKey: FilterStatesKey;
    subFilterKey?: string;
    props: CheckboxProps;
    // checkbox will hide in the filter section but display on the applied filter bar if it's applied
    hideInFilters?: boolean;
    // filter bar will display if it is true
    displayOnFilterBar?: boolean;
    filterBarOrder?: number;
    adminOnly?: boolean;
    displayOnMobileFilterBar?: boolean;
}
export type CheckboxFilterState = Pick<CheckboxProps, 'checked' | 'disabled'> &
    Pick<CheckboxFilter, 'kind'>;

interface FilterCheckboxProps {
    filter: CheckboxFilter;
    state: CheckboxFilterState;
    updateFilter: (
        filterKey: FilterStatesKey,
        state: Partial<CheckboxFilterState>
    ) => void;
    disabled?: boolean;
}

const FilterCheckbox = ({
    filter,
    state,
    updateFilter,
    disabled,
}: FilterCheckboxProps) => {
    const { props, filterKey } = filter;
    return (
        <Checkbox
            {...props}
            checked={!!state.checked}
            disabled={state.disabled || disabled}
            onChange={(_, data) =>
                updateFilter(filterKey, {
                    kind: 'Checkbox',
                    checked: !!data?.checked,
                })
            }
        />
    );
};

export default FilterCheckbox;
